import React, { Fragment, useEffect, useState } from "react";

import {
  ReportsMainCollapse,
  CollapsibleParaContent,
  CollapsibleListContent,
} from "../ReportsView";
import { toTitleCase } from "../../../utils/filters";

const XBARReportMain = ({ accordionId, reportData }) => {
  const sections = reportData.report_data.sections;
  const [reportSections, setReportSections] = useState([]);

  useEffect(() => {
    setReportSections(renderAllMainCollapse(sections, accordionId));
  }, []);

  const getParaTypeContent = (title, content) => {
    return <CollapsibleParaContent text={content} title={toTitleCase(title)} />;
  };

  const getListTypeContent = (title, content) => {
    return <CollapsibleListContent content={content} title={toTitleCase(title)} />;
  };

  const getQATypeContent = (title, content) => {
    if (Array.isArray(content) && content.length > 0) {
      return (
        <div>
          {content.map((item) => {
            return (
              <CollapsibleParaContent
                key={item.question}
                text={item.answer}
                title={toTitleCase(item.question)}
              />
            );
          })}
        </div>
      );
    } else {
      return (
        <CollapsibleParaContent
          text="Clinician assessment is pending. When completed, this information will be populated here."
          title={toTitleCase(title)}
        />
      );
    }
  };

  const getLsQATypeContent = (title, content) => {
    if (Array.isArray(content) && content.length > 0) {
      return (
        <div>
          {content.map((item) => {
            return (
              <CollapsibleParaContent
                key={item.statement}
                text={item.response}
                title={toTitleCase(item.statement)}
              />
            );
          })}
        </div>
      );
    } else {
      return (
        <CollapsibleParaContent
          text="Clinician assessment is pending. When completed, this information will be populated here."
          title={toTitleCase(title)}
        />
      );
    }
  };

  const renderMainCollapseContent = (subSection) => {
    let title = subSection.title;
    let scrollId = title.replace(/\s+/g, "-").toLowerCase();
    let type = subSection.type;
    let content =
      subSection.content ||
      "Clinician assessment is pending. When completed, this information will be populated here.";
    let renderedContent = (
      <p>
        Clinician assessment is pending. When completed, this information will be populated here.
      </p>
    );

    switch (type) {
      case "paragraph":
        renderedContent = getParaTypeContent(title, content);
        break;

      case "list":
        renderedContent = getListTypeContent(title, content);
        break;

      case "Q&A":
        renderedContent = getQATypeContent(title, content);
        break;

      case "LsQA":
        renderedContent = getLsQATypeContent(title, content);
        break;

      default:
        renderedContent = (
          <p>
            Clinician assessment is pending. When completed, this information will be populated
            here.
          </p>
        );
    }

    // wrapping extra `span` to add `id` for scrollable behavior from sidebar links.
    return <span id={scrollId}>{renderedContent}</span>;
  };

  const renderAllMainCollapse = (sections, accordionId) => {
    return sections.map((section) => {
      let sectionTitle = section.title;
      let subSections = section.sections;
      let uid = section.uid;

      return (
        <ReportsMainCollapse
          accordionId={`#${accordionId}`}
          key={uid}
          title={toTitleCase(sectionTitle)}
          uid={uid}
        >
          {subSections.map((subSection) => {
            const { uid } = subSection;

            return <Fragment key={uid}>{renderMainCollapseContent(subSection)}</Fragment>;
          })}
        </ReportsMainCollapse>
      );
    });
  };

  return (
    <div className="accordion" id={accordionId}>
      {reportSections}
    </div>
  );
};

export default XBARReportMain;
